var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"d-flex flex-column",staticStyle:{"height":"100%"},attrs:{"color":"transparent","elevation":"0"}},[_c('v-card-text',{staticClass:"d-flex flex-grow-1 justify-center align-center"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }